<template>
    <card>
        <card-header>
            <card-overline>Alternatives Kundenangebot erstellen</card-overline>
        </card-header>
        <card-content>
            <table class="table table--stripped table--card table--td-top">
                <thead>
                <tr>
                    <th>
                        PF-Nr
                    </th>
                    <th>
                        Kunde
                    </th>
                    <th class="text-right">
                        Stückzahl
                    </th>
                    <th class="text-right">
                        Preis Produzent
                    </th>
                    <th class="text-center">
                        Angebotspreis
                    </th>
                    <th class="text-right">
                        Lieferzeit Anfrage
                    </th>
                    <th class="text-right">
                        Lieferzeit Produzent
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="offerAskForQuote in createAlternateOfferAskForQuotesTable" :key="offerAskForQuote.index">
                    <td>
                        <Link
                            :href="$$route('ask-for-quote', {'askForQuote': offerAskForQuote.id} )">
                            {{ offerAskForQuote.pfnumber }}
                        </Link>
                    </td>
                    <td>{{ offerAskForQuote.client_user.company }}</td>
                    <td class="text-right" v-html="offerAskForQuote.lot_qty"></td>
                    <td class="text-right" v-html="offerAskForQuote.lot_producer_price"></td>
                    <td class="text-right" v-html="offerAskForQuote.lot_net_price"></td>

                    <td class="text-right">{{ offerAskForQuote.bid_rounds?.[0]?.delivery_days_for_producer }}</td>
                    <td class="text-right" v-html="offerAskForQuote.lot_delivery" />
                </tr>
                </tbody>
            </table>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
export default {
    name: 'CreateAlternateOffer',
    components: {CardContent, CardOverline, CardHeader, Card},
    props: {
        createAlternateOfferAskForQuotes: Object,
    },
    computed: {
        createAlternateOfferAskForQuotesTable() {

            let askForQuotes = Array;

            return Object.keys(this?.createAlternateOfferAskForQuotes).map(key => {
                askForQuotes[key] = this.createAlternateOfferAskForQuotes[key];

                let lotQty = [], lotProducerPrice = [], lotNetPrice = [], lotDelivery = [];

                this.createAlternateOfferAskForQuotes[key].client_offers.forEach(offer => {
                    lotQty.push(offer.amount);
                    lotProducerPrice.push(this.$currency(offer.producer_price));
                    lotNetPrice.push(this.$currency(offer.net_price));
                    lotDelivery.push(offer.delivery_days_producer);
                });

                askForQuotes[key].lot_qty = lotQty.filter(lot => lot !== null).join('<br>');
                askForQuotes[key].lot_producer_price = lotProducerPrice.filter(lot => lot !== null).join('<br>');
                askForQuotes[key].lot_net_price = lotNetPrice.filter(lot => lot !== null).join('<br>');
                askForQuotes[key].lot_delivery = lotDelivery.filter(lot => lot !== null).join('<br>');

                return askForQuotes[key];
            });
        },
    },
};
</script>

<style scoped>

</style>
